import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { API_BASE_URL } from '../config';
import { usePermissions } from '../context/PermissionsContext';
import { useAuth } from '../context/AuthContext';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import './login.css';
import './AwaitingApproval.css';

function AwaitingApproval() {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const { clearPermissions, fetchUserPermissions } = usePermissions();
  const { clearSessionExpired } = useAuth();
  const [status, setStatus] = useState(null);
  const [checking, setChecking] = useState(true);

  const checkAccess = useCallback(async () => {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/me/membership-access`);
      if (!response.ok) {
        setChecking(false);
        return;
      }
      const data = await response.json();
      setStatus(data);
      if (data?.hasProvisionedAccess && !data?.awaitingApproval) {
        await fetchUserPermissions();
        navigate('/home', { replace: true });
      }
    } catch (err) {
      console.error('Failed to check membership access:', err);
    } finally {
      setChecking(false);
    }
  }, [fetchUserPermissions, navigate]);

  useEffect(() => {
    checkAccess();
    const timer = setInterval(checkAccess, 20000);
    return () => clearInterval(timer);
  }, [checkAccess]);

  const handleLogout = () => {
    cookies.remove('token', { path: '/' });
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiresAt');
    localStorage.removeItem('tenants');
    localStorage.removeItem('currentTenant');
    clearPermissions();
    clearSessionExpired();
    navigate('/');
  };

  const pending = status?.pendingRequests?.[0];
  const tenantName = pending?.tenant_name || 'your organisation';

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-card awaiting-card">
          <div className="login-header">
            <div className="logo-container">
              <img
                src="/favicon.ico"
                alt="Wandawazi Flow Logo"
                className="login-logo"
                style={{ width: '120px', height: 'auto', maxHeight: '50px', objectFit: 'contain', filter: 'none' }}
              />
            </div>
            <h1 className="login-title">Awaiting approval</h1>
            <p className="login-subtitle">
              {checking
                ? 'Checking your Flow access…'
                : `Your request to join ${tenantName} is waiting for an administrator to approve it.`}
            </p>
          </div>
          <div className="awaiting-body">
            <p>
              You can stay on this page. We will let you in automatically once access is granted.
            </p>
            <button type="button" className="awaiting-refresh" onClick={checkAccess}>
              Check again
            </button>
            <button type="button" className="awaiting-logout" onClick={handleLogout}>
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AwaitingApproval;
